// extracted by mini-css-extract-plugin
export var content = "layout-module--content--2bfc1";
export var footer = "layout-module--footer--ad7d0";